import React, { useContext } from 'react';
import { X, ArrowLeft } from 'lucide-react';
import Button from '../../../components/Button';
import GlobalContext from '../../../utils/GlobalContext';

export default function CommentAppBarComponent({
  onClickExpand,
  onClickClose,
}) {
  const { locales } = useContext(GlobalContext);
  return (
    <div className="comment-app-bar-component">
      <Button
        onClick={onClickExpand}
        size="evenDefault"
        variant="ghost"
        aria-label="Back to chat section"
      >
        <ArrowLeft />
      </Button>

      <div className="comment-app-bar-component__title">
        {locales.chatSystem.backToMessaging}
      </div>

      <Button
        onClick={onClickClose}
        size="evenDefault"
        variant="ghost"
        aria-label="Minimise chat section"
      >
        <X />
      </Button>
    </div>
  );
}
